export function csvToJson(csvString) {
  const rows = csvString.trim().split("\n");
  const headers = parseCsvLine(rows[0]);

  return rows.slice(1).map(row => {
    const values = parseCsvLine(row);
    return headers.reduce((obj, header, index) => {
      obj[header] = values[index] || '';
      return obj;
    }, {});
  });
}

function parseCsvLine(line: string): string[] {
  const result: string[] = [];
  let current = '';
  let inQuotes = false;

  for (let i = 0; i < line.length; i++) {
    const ch = line[i];
    if (inQuotes) {
      if (ch === '"') {
        if (line[i + 1] === '"') {
          current += '"';
          i++;
        } else {
          inQuotes = false;
        }
      } else {
        current += ch;
      }
    } else if (ch === '"') {
      inQuotes = true;
    } else if (ch === ',') {
      result.push(current.trim());
      current = '';
    } else {
      current += ch;
    }
  }
  result.push(current.trim());
  return result;
}

export async function parseCsvFile(csvFile: File, csvDelimiter = ','): Promise<Record<string, string>[]> {
  const contents = await csvFile.text();
  const headers = contents.slice(0, contents.indexOf('\n')).trim().split(csvDelimiter);
  const rows = contents.slice(contents.indexOf('\n') + 1).trim().split('\n');
  return rows.map(row => {
      const values = row.split(new RegExp(`(${csvDelimiter}(?=(?:[^"]*"[^"]*")*[^"]*$))`));
      const obj = {};
      let valueIndex = 0;
      headers.forEach(header => {
          obj[header] = values[valueIndex] ? values[valueIndex].replace(/^[,"']|[,"']$/g, '').trim().replace('"', "") : '';
          valueIndex += 2;
      });
      return obj;
  });
}

export function exportAsCsv<T extends Record<string, any>>(rows: T[], columns?: string[]): string {
  if (!rows?.length) {
    return '';
  }
  const cols = columns ?? Array.from(
    rows.reduce((set, r) => {
      Object.keys(r).forEach(k => set.add(k));
      return set;
    }, new Set<string>())
  );
  const esc = (v: any) => {
    if (v === null || v === undefined) return '';
    const s = String(v);
    return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const header = cols.map(esc).join(',');
  const body   = rows.map(r => cols.map(c => esc(r[c])).join(',')).join('\r\n');
  return header + '\r\n' + body;
}